<template>
  <div>
    <!-- <h1>Header</h1> -->
    <!-- <button @click="showPurvyModal()" class="mylisting-button dark-button mt-5 mb-3">Dear </button>
    <hr> -->

    <modal name="purvy-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" style="text-align: left;">
        <p>Dear ,</p>
        <p></p>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  methods: {
    showPurvyModal() {
      this.$modal.show('purvy-modal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue